import gam from 'src/utils/gam'
import PATHS from 'src/router/paths'

const columns = {
  [PATHS.INTERNAL.TIME_ROLLUP]: [
    {
      align: 'start',
      columnName: 'Billing Code',
      class: 'org-code',
      key: 'billingCode',
      columnValue: (item) => item.billingCode,
      fieldType: 'text',
      sortable: true,
      linkProperty: null,
      isLinkExternal: false,
      linkTitle: null,
      width: 120,
    },
    {
      align: 'start',
      columnName: 'Client',
      class: 'org-name',
      key: 'clientName',
      columnValue: (item) => item.clientName,
      fieldType: 'text',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 150,
    },
    {
      align: 'start',
      columnName: 'Person',
      class: 'person-name',
      key: 'personName',
      columnValue: (item) => item.personName,
      fieldType: 'text',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 130,
    },
    {
      align: 'start',
      columnName: 'Date',
      class: 'time-entry-date',
      key: 'timeEntryDate',
      columnValue: (item) => item.timeEntryDate,
      fieldType: 'date',
      exportAs: ['date', 'L'],
      formatAs: 'date',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 120,
    },
    {
      align: 'start',
      columnName: 'HH:MM',
      class: 'billable-duration',
      key: 'billableActionDuration',
      columnValue: (item) => item.billableActionDuration,
      fieldType: 'hhmm',
      formatAs: 'hhmm',
      exportAs: null,
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      tooltip: 'Durations are converted to hours and minutes for display purposes only.',
      width: 120,
    },
    {
      align: 'start',
      columnName: 'Time Type',
      class: 'time-type',
      key: 'timeClassificationName',
      columnValue: (item) => item.timeClassificationName,
      fieldType: 'text',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 130,
    },
    {
      align: 'start',
      columnName: 'Project',
      class: 'project-name',
      key: 'projectName',
      columnValue: (item) => item.projectName,
      fieldType: 'text',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 130,
    },
    {
      align: 'start',
      columnName: 'Notes',
      class: 'work-note',
      key: 'workNote',
      columnValue: (item) => item.workNote,
      fieldType: 'text',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      minWidth: 150,
      width: null,
    },
  ],
  organization: [
    {
      align: 'start',
      class: 'org-billing-code',
      columnName: 'Billing Code',
      columnValue: (item) => item.billingCode,
      fieldType: 'text',
      href: (item) => `/internal/organization/${item.billingCode}`,
      isLinkExternal: false,
      key: 'billingCode',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-name',
      columnName: 'Name',
      columnValue: (item) => item.orgName,
      fieldType: 'text',
      initialSorted: true,
      key: 'orgName',
      sortable: true,
      width: 280,
    },
    {
      align: 'start',
      class: 'org-network-code',
      columnName: 'Network Code',
      columnValue: (item) => item.networkCode,
      fieldType: 'text',
      isLinkExternal: true,
      initialSorted: true,
      key: 'networkCode',
      linkProperty: 'adServerUrl',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-active',
      columnName: 'Active',
      columnValue: (item) => item.isActive,
      fieldType: 'boolean',
      isLinkExternal: false,
      key: 'isActive',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-deleted',
      columnName: 'Deleted',
      columnValue: (item) => item.isDeleted,
      fieldType: 'boolean',
      isLinkExternal: false,
      key: 'isDeleted',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-purpose',
      columnName: 'Internal Use Only',
      columnValue: (item) => item.isInternalUseOnly,
      fieldType: 'boolean',
      isLinkExternal: false,
      key: 'isInternalUseOnly',
      linkProperty: null,
      linkTitle: null,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-is-team-enabled',
      columnName: 'Team-Enabled',
      columnValue: (item) => item.isTeamEnabled,
      fieldType: 'boolean',
      initialSorted: true,
      key: 'isTeamEnabled',
      sortable: true,
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-is-timesheet-enabled',
      columnName: 'Timesheet-Enabled',
      columnValue: (item) => item.hasTimesheetReport,
      fieldType: 'boolean',
      initialSorted: true,
      key: 'hasTimesheetReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-discrepancy',
      columnName: 'Discrepancy',
      columnValue: (item) => item.hasDiscrepancyReport,
      fieldType: 'boolean',
      href: (item) => {
        const { hasDiscrepancy, publisherId } = item

        return hasDiscrepancy ? `/delivery/discrepancy/${publisherId}` : null
      },
      initialSorted: true,
      key: 'hasDiscrepancyReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-pacing',
      columnName: 'Pacing',
      columnValue: (item) => item.hasPacingReport,
      fieldType: 'boolean',
      href: (item) => {
        const { hasPacing, publisherId } = item

        return hasPacing ? `/delivery/pacing/${publisherId}` : null
      },
      initialSorted: true,
      key: 'hasPacingReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-programmatic',
      columnName: 'AdX Health',
      columnValue: (item) => item.hasHealthAdxReport,
      fieldType: 'boolean',
      href: (item) => {
        const { hasHealthAdx, publisherId } = item

        if (hasHealthAdx) return `/programmatic/${PATHS.PROGRAMMATIC.HEALTH.ADX}/${publisherId}`

        return null
      },
      initialSorted: true,
      key: 'hasHealthAdxReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-programmatic',
      columnName: 'Network Health',
      columnValue: (item) => item.hasHealthNetworkReport,
      fieldType: 'boolean',
      href: (item) => {
        const { hasHealthNetwork, publisherId } = item

        if (hasHealthNetwork) return `/programmatic/${PATHS.PROGRAMMATIC.HEALTH.NETWORK}/${publisherId}`

        return null
      },
      initialSorted: true,
      key: 'hasHealthNetworkReport',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'org-has-programmatic',
      columnName: 'Yield Partner',
      columnValue: (item) => item.hasYieldPartnerReport,
      fieldType: 'boolean',
      href: (item) => {
        const { hasYieldPartner, publisherId } = item

        if (hasYieldPartner) return `/programmatic/${PATHS.PROGRAMMATIC.YIELD.PARTNER}/${publisherId}`

        return null
      },
      initialSorted: true,
      key: 'hasYieldPartnerReport',
      sortable: true,
      width: 150,
    },
  ],
  person: [
    {
      align: 'start',
      class: 'person-associationId',
      columnName: 'Association',
      columnValue: (item) => item.associationId,
      fieldType: 'text',
      formatAs: null,
      key: 'associationId',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-id',
      columnName: 'DB ID',
      columnValue: (item) => item.personId,
      href: (item) => `/internal/person/${item.personId}`,
      fieldType: 'text',
      key: 'personId',
      sortable: true,
      visible: false,
      width: 120,
    },
    {
      align: 'start',
      class: 'person-name-last',
      columnName: 'Last Name',
      columnValue: (item) => item.personNameLast,
      href: (item) => `/internal/person/${item.personId}`,
      fieldType: 'text',
      key: 'personNameLast',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-name-first',
      columnName: 'First Name',
      columnValue: (item) => item.personNameFirst,
      fieldType: 'text',
      key: 'personNameFirst',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-email',
      columnName: 'Email',
      columnValue: (item) => item.email,
      fieldType: 'text',
      key: 'email',
      sortable: true,
      width: 250,
    },

    {
      align: 'start',
      class: 'person-user-active',
      columnName: 'Active',
      columnValue: (item) => item?.isPersonUserActive,
      fieldType: 'boolean',
      key: 'isPersonUserActive',
      sortable: true,
      tooltip: 'Active person and user records',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-created',
      columnName: 'Created',
      columnValue: (item) => item.created_dt || 0,
      exportAs: ['date', 'L'],
      fieldType: 'date',
      formatAs: 'date',
      key: 'created_dt',
      sortable: true,
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-updated',
      columnName: 'Updated',
      columnValue: (item) => item.updated_dt || 0,
      exportAs: ['date', 'L'],
      fieldType: 'date',
      formatAs: 'date',
      key: 'updated_dt',
      sortable: true,
      tooltip: 'Last Updated',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: (value) => `font-weight-bold person-valid ${(['false'].includes(value) && 'toasted--text') || ''}`,
      columnName: 'Has Valid Configs',
      columnValue: (item) => item.isConfigValid,
      fieldType: 'boolean',
      key: 'isConfigValid',
      sortable: true,
      tooltip: 'Records Are Configured Correctly',
      width: 150,
    },
    {
      align: 'start',
      class: 'person-config',
      columnName: 'Config Errors',
      columnValue: (item) => item.hasAccessErrors,
      fieldType: 'boolean',
      formatAs: ['join', ', '],
      key: 'hasAccessErrors',
      sortable: true,
      tooltip: 'Access Has Been Configured',
      width: 180,
    },
    {
      align: 'start',
      class: 'person-authorized',
      columnName: 'Auth Configured',
      columnValue: (item) => item.canAccessApps,
      fieldType: 'boolean',
      key: 'canAccessApps',
      sortable: true,
      tooltip: 'Auth Has Been Configured',
      width: 180,
    },
    {
      align: 'start',
      class: 'person-is-person',
      columnName: 'Person Exists',
      columnValue: (item) => item.isPerson,
      fieldType: 'boolean',
      key: 'isPerson',
      sortable: true,
      tooltip: 'Person Record Exists',
      visible: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-authorized',
      columnName: 'Person Auth',
      columnValue: (item) => item.isPersonAuthorized,
      fieldType: 'boolean',
      key: 'isPersonAuthorized',
      sortable: true,
      tooltip: 'Person Auth Is Valid',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-deleted',
      columnName: 'Person Deleted',
      columnValue: (item) => item.isDeleted,
      fieldType: 'boolean',
      key: 'isDeleted',
      sortable: true,
      tooltip: 'Person Is Soft Deleted',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-active',
      columnName: 'Person Active',
      columnValue: (item) => item.isActive,
      fieldType: 'boolean',
      key: 'isActive',
      sortable: true,
      tooltip: 'Person Record Is Active',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-role',
      columnName: 'Person Role',
      columnValue: (item) => item.personRole,
      fieldType: 'text',
      key: 'personRole',
      sortable: true,
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-is-user',
      columnName: 'User Exists',
      columnValue: (item) => item.isUser,
      fieldType: 'boolean',
      key: 'isUser',
      sortable: true,
      tooltip: 'User Record Exists',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-authorized',
      columnName: 'User Auth',
      columnValue: (item) => item.isUserAuthorized,
      fieldType: 'boolean',
      key: 'isUserAuthorized',
      sortable: true,
      tooltip: 'User Auth Is Valid',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-active',
      columnName: 'User Active',
      columnValue: (item) => item?.isUserActive,
      fieldType: 'boolean',
      key: 'isUserActive',
      sortable: true,
      tooltip: 'User Record Is Active',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-level',
      columnName: 'User Level',
      columnValue: (item) => item['access.level'],
      fieldType: 'text',
      key: 'access.level',
      sortable: true,
      tooltip: 'User Level',
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-role',
      columnName: 'User Role',
      columnValue: (item) => item['access.role'],
      fieldType: 'text',
      key: 'access.role',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-expires',
      columnName: 'User Expires',
      columnValue: (item) => item['access.expires'] || '2200-01-01T00:00:00',
      exportAs: ['date', 'L'],
      fieldType: 'date',
      formatAs: 'date',
      key: 'access.expires',
      sortable: true,
      tooltip: 'Expire Date Overrides Access',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-permissions-dev',
      columnName: 'Permissions: Dev',
      columnValue: (item) => item['access.permissions.dev'],
      exportAs: null,
      fieldType: 'boolean',
      formatAs: null,
      key: 'access.permissions.dev',
      sortable: true,
      tooltip: 'Permissions: Developer',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-permissions-pacing',
      columnName: 'Permissions: Pacing',
      columnValue: (item) => item['access.permissions.pacing'],
      exportAs: null,
      fieldType: 'boolean',
      formatAs: null,
      key: 'access.permissions.pacing',
      sortable: true,
      tooltip: 'Permissions: Pacing',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-permissions-discrepancy',
      columnName: 'Permissions: Discrepancy',
      columnValue: (item) => item['access.permissions.discrepancy'],
      exportAs: null,
      fieldType: 'boolean',
      formatAs: null,
      key: 'access.permissions.discrepancy',
      sortable: true,
      tooltip: 'Permissions: Discrepancy',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-user-permissions-programmatic',
      columnName: 'Permissions: Programmatic',
      columnValue: (item) => item['access.permissions.programmatic'],
      exportAs: null,
      fieldType: 'boolean',
      formatAs: null,
      key: 'access.permissions.programmatic',
      sortable: true,
      tooltip: 'Permissions: Programmatic',
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-org-billing-codes',
      columnName: 'Billing Codes',
      columnValue: (item) => item.billingCodes,
      fieldType: 'text',
      formatAs: ['join', ', '],
      key: 'billingCodes',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-org-network-codes',
      columnName: 'Network Codes',
      columnValue: (item) => item.networkCodes,
      fieldType: 'text',
      formatAs: ['join', ', '],
      key: 'networkCodes',
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'person-org-ids',
      columnName: 'Org IDs',
      columnValue: (item) => item.orgIds,
      fieldType: 'text',
      formatAs: ['join', ', '],
      key: 'orgIds',
      sortable: true,
      visible: false,
      width: 120,
    },
    {
      align: 'start',
      class: 'person-org-names',
      columnName: 'Org Names',
      columnValue: (item) => item.orgNames,
      fieldType: 'text',
      formatAs: ['join', ', '],
      href: (item) => (!item.networkCode && null) || gam.network(item.networkCode),
      key: 'orgNames',
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'person-team-codes',
      columnName: 'Team Codes',
      columnValue: (item) => item.teamCodes,
      fieldType: 'text',
      formatAs: ['join', ', '],
      key: 'teamCodes',
      sortable: true,
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-team-ids',
      columnName: 'Team IDs',
      columnValue: (item) => item.teamIds,
      fieldType: 'text',
      formatAs: ['join', ', '],
      key: 'teamIds',
      sortable: true,
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-team-names',
      columnName: 'Team Names',
      columnValue: (item) => item.teamNames,
      fieldType: 'text',
      formatAs: ['join', ', '],
      key: 'teamNames',
      sortable: true,
      width: 192,
    },
    {
      align: 'start',
      class: 'person-manager-id',
      columnName: 'MID',
      columnValue: (item) => (item.isInternal ? item.managerPersonId || 'None' : 'N/A'),
      fieldType: 'text',
      filterKey: 'personId',
      href: (item) => {
        const { isInternal, managerPersonId } = item
        const hasManager = isInternal && managerPersonId
        return hasManager && `/internal/person/${managerPersonId}`
      },
      key: 'managerPersonId',
      sortable: true,
      tooltip: 'Manager ID',
      visible: false,
      width: 102,
    },
    {
      align: 'start',
      class: 'person-manager-name',
      columnName: 'Manager',
      columnValue: (item) => (item.isInternal ? item.managerPersonName || 'None' : 'N/A'),
      fieldType: 'text',
      filterKey: 'personName',
      href: (item) => {
        const { isInternal, managerPersonId } = item
        const hasManager = isInternal && managerPersonId
        return hasManager && `/internal/person/${managerPersonId}`
      },
      key: 'managerPersonName',
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'person-custom-analytics-active',
      columnName: 'Custom Analytics',
      columnValue: (item) => Array.isArray(item.hasCustomAnalyticsActive) && item.customAnalyticsActive.map((customAnalytic) => customAnalytic.href),
      fieldType: 'text',
      formatAs: ['join', ', '],
      key: 'customAnalyticsActive',
      sortable: true,
      tooltip: 'Active Custom Analytics',
      width: 210,
    },
    {
      align: 'start',
      class: 'person-custom-analytics-all',
      columnName: 'Custom Analytics All',
      columnValue: (item) => (Array.isArray(item.hasCustomAnalytics) && item.hasCustomAnalytics.map((customAnalytic) => customAnalytic.href)) || item.hasCustomAnalytics,
      fieldType: 'text',
      formatAs: ['join', ', '],
      key: 'hasCustomAnalytics',
      sortable: true,
      tooltip: 'All Custom Analytics Set on the User Record',
      visible: false,
      width: 210,
    },
    {
      align: 'start',
      class: 'person-filters',
      columnName: 'Filters',
      columnValue: (item) => {
        const { hasFilters, settings } = item || {}
        const { filters } = settings || {}
        return (!hasFilters && filters?.map((filter) => filter.name)) || []
      },
      fieldType: 'text',
      formatAs: ['join', ', '],
      key: 'hasFilters',
      sortable: true,
      width: 120,
    },
  ],
  project: [
    {
      align: 'start',
      columnName: 'Code',
      class: 'project-code',
      key: 'projectCode',
      href: (item) => `/internal/project/${item.projectCode}`,
      columnValue: (item) => item.projectCode,
      fieldType: 'text',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 120,
    },
    {
      align: 'start',
      columnName: 'Name',
      class: 'project-name',
      key: 'projectName',
      columnValue: (item) => item.projectName,
      fieldType: 'text',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 150,
    },
    {
      align: 'start',
      columnName: 'Active',
      class: 'project-deleted',
      key: 'isDeleted',
      columnValue: (item) => item.isDeleted,
      fieldType: 'boolean',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 150,
    },
  ],
  [PATHS.INTERNAL.TIME_SHEET]: [
    {
      align: 'start',
      columnName: 'Billing Code',
      class: 'org-code',
      key: 'billingCode',
      columnValue: (item) => item.billingCode,
      fieldType: 'text',
      sortable: true,
      linkProperty: null,
      isLinkExternal: false,
      linkTitle: null,
      width: 75,
    },
    {
      align: 'start',
      columnName: 'Client',
      class: 'org-name',
      key: 'clientName',
      columnValue: (item) => item.clientName,
      fieldType: 'text',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 120,
    },
    {
      align: 'start',
      columnName: 'Person',
      class: 'person-name',
      key: 'personName',
      columnValue: (item) => item.personName,
      fieldType: 'text',
      exportOnly: true,
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 120,
    },
    {
      align: 'start',
      columnName: 'Date',
      class: 'time-entry-date',
      key: 'timeEntryDate',
      columnValue: (item) => item.timeEntryDate,
      fieldType: 'date',
      exportOnly: true,
      exportAs: ['date', 'L'],
      formatAs: 'date',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 102,
    },
    {
      align: 'start',
      columnName: 'Time',
      class: 'billable-duration',
      key: 'billableActionDuration',
      columnValue: (item) => item.billableActionDuration,
      fieldType: 'number',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 75,
    },
    {
      align: 'start',
      columnName: 'Time Type',
      class: 'time-type',
      key: 'timeClassificationName',
      columnValue: (item) => item.timeClassificationName,
      fieldType: 'text',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 120,
    },
    {
      align: 'start',
      columnName: 'Project',
      class: 'project-name',
      key: 'projectName',
      columnValue: (item) => item.projectName,
      fieldType: 'text',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 120,
    },
    {
      align: 'start',
      columnName: 'Notes',
      class: 'work-note',
      key: 'workNote',
      columnValue: (item) => item.workNote,
      fieldType: 'text',
      sortable: true,
      linkProperty: false,
      isLinkExternal: false,
      linkTitle: null,
      width: 130,
    },
  ],
}

export default columns
